import { NotificationResources } from '../types/notification';

export const getRoverRoutes = ({ resourceType, resourceTypeId, meta }: IGetPlatformRoutes): string => {
  switch (resourceType) {
    case NotificationResources.ClientApplication:
      return `/app/rover/client-applications/list/${resourceTypeId}`;
    case NotificationResources.PartnerProposal:
      return `/app/rover/partner-proposals/list/${resourceTypeId}`;
    case NotificationResources.Application:
      if (meta?.formId) {
        return `/app/rover/application_forms/${meta.formId}/applications/${resourceTypeId}/application_details`;
      }
      return '/app/rover/application_forms';
    default:
      throw new Error('resource type not recognized for rover app');
  }
};
